function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useState } from 'react';
import { CustomModal, useOpenUnsavedChangesModal } from 'seagull';
import { ClientOnboarding } from "../../client-flow/clientOb/ClientOnboarding";
import { COBStep, PreviewState } from "../../client-flow/clientOb/ClientOnboarding.utils";
import { CobBrandingProvider, OverrideBranding, useCobBranding } from "../../client-flow/clientOb/CobBrandingContext";
import { CobStorageProvider, mockStorageImpl } from "../../client-flow/clientOb/CobStorageContext";
import { useIoContext, useStoreActions, useStoreStatic } from "../../contexts";
import { useFeatureFlags } from "../../hooks/useFeatureFlags";
import { relationshipModel } from "../../models";
import { selectors } from "../../store/state-selectors";
import { useAppConfig } from "../../store/store-context";
import RestfulWrapper from "../RestfulWrapper/RestfulWrapper";
import { getRelationshipFromDraft, getSetupBrandRelationship } from "./ClientPreview.utils";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function UnsavedChangesPopup(_ref) {
  let {
    registerCanDismiss,
    isInBrandSetup
  } = _ref;
  const {
    isDirty
  } = useCobBranding();
  const {
    logBI
  } = useStoreActions();
  const {
    SET_UP_BRAND_CLIENT_PREVIEW = false
  } = useFeatureFlags();
  const openUnsavedChangesModal = useOpenUnsavedChangesModal();
  registerCanDismiss(async () => {
    if (!isDirty) return true;
    const confirmed = await openUnsavedChangesModal({
      testid: 'client-preview-unsaved-popup',
      title: isInBrandSetup() && SET_UP_BRAND_CLIENT_PREVIEW ? 'Unsaved brand changes' : undefined
    });
    if (confirmed) {
      logBI(11220);
    }
    return confirmed;
  });
  return null;
}
function ClientPreviewWithRelationship(props) {
  const {
    isSetupBrand,
    dismissModal,
    registerCanDismiss
  } = props;
  const [currentStep, setCurrentStep] = useState(COBStep.welcome);
  const [relationship, setRelationship] = useState(props.relationship);
  const [currentPreviewState, setCurrentPreviewState] = useState(isSetupBrand ? PreviewState.SetupBrand : PreviewState.Preview);
  function updateRelationshipLogo(logoUrl) {
    setRelationship(r => relationshipModel.setVendorLogo(r, logoUrl));
  }
  const isInBrandSetup = () => currentPreviewState === PreviewState.SetupBrand;
  return /*#__PURE__*/_jsx(CobStorageProvider, {
    impl: mockStorageImpl,
    children: /*#__PURE__*/_jsxs(CobBrandingProvider, {
      onLogoChange: updateRelationshipLogo,
      children: [/*#__PURE__*/_jsx(OverrideBranding, {
        children: /*#__PURE__*/_jsx(UnsavedChangesPopup, {
          registerCanDismiss: registerCanDismiss,
          isInBrandSetup: isInBrandSetup
        })
      }), /*#__PURE__*/_jsx(ClientOnboarding, {
        disableMobile: true,
        previewState: isSetupBrand ? PreviewState.SetupBrand : PreviewState.Preview,
        onPreviewStateChange: setCurrentPreviewState,
        dismissPreviewModal: dismissModal,
        relationship: relationship,
        currentStep: currentStep,
        setCurrentStep: setCurrentStep,
        refresh: props.refresh,
        source: props.source
      })]
    })
  });
}
export function ClientPreview(props) {
  const {
    type,
    dismissModal,
    registerCanDismiss,
    source
  } = props;
  const {
    api
  } = useStoreActions();
  const {
    getState
  } = useStoreStatic();
  const {
    getNow
  } = useIoContext();
  const {
    generateUniqueId
  } = useAppConfig();
  const {
    SET_UP_BRAND_CLIENT_PREVIEW = false
  } = useFeatureFlags();
  return /*#__PURE__*/_jsx(CustomModal, {
    width: "90%",
    height: "90%",
    onClose: dismissModal,
    minWidth: "1200px",
    maxWidth: "auto",
    maxHeight: "auto",
    "data-testid": "client-preview-modal",
    fullSizeHeader: true,
    hideCloseBtn: SET_UP_BRAND_CLIENT_PREVIEW,
    children: /*#__PURE__*/_jsx(RestfulWrapper, {
      fetch: async () => {
        if (type === 'draft') {
          return getRelationshipFromDraft(_objectSpread(_objectSpread({}, props.draftInfo), {}, {
            now: getNow(),
            userInfo: getState().userInfo,
            worksAt: selectors.user.business(getState()),
            generateUniqueId
          }));
        } else if (type === 'relationshipId') {
          return await api.relationship.get(props.relationshipId);
        } else if (type === 'originalProposal') {
          return await api.relationship.getOriginalProposal(props.relationshipId);
        } else {
          return getSetupBrandRelationship({
            legalTerms: props.setupBrandInfo.legalTerms,
            userInfo: getState().userInfo,
            worksAt: selectors.user.business(getState())
          });
        }
      },
      renderChild: _ref2 => {
        let {
          data,
          refresh
        } = _ref2;
        return /*#__PURE__*/_jsx(ClientPreviewWithRelationship, {
          isSetupBrand: type === 'setupBrand',
          relationship: data,
          dismissModal: dismissModal,
          registerCanDismiss: registerCanDismiss,
          refresh: refresh,
          source: source
        });
      }
    })
  });
}